var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    borders = _ref.borders,
    transitions = _ref.transitions;
  return {
    margin: spacing.xSmall,
    padding: spacing.xSmall,
    pillMargin: spacing.small,
    background: colors.contrasts.grey1111,
    choiceBackground: colors.contrasts.white1010,
    choiceBorderWidth: borders.widthMedium,
    choiceBorderColor: colors.contrasts.grey1214,
    choiceBorderRadius: borders.radiusMedium,
    choiceMargin: spacing.xSmall,
    emptyContainerBackground: colors.contrasts.white1010,
    emptyContainerBorderColor: colors.contrasts.grey1214,
    emptyContainerorderWidth: borders.widthMedium,
    emptyContainerPadding: spacing.xSmall,
    focusBorderColor: colors.contrasts.blue4570,
    focusBorderWidth: borders.widthSmall,
    focusBorderRadius: borders.radiusMedium,
    choicesBackgroundTransition: "all ".concat(transitions.duration)
  };
};
export default generateComponentTheme;